import { routeConfig } from './login';
import { routeConfigPassword } from './password';
import { routeConfigPasswordReset } from './passwordReset';
import { routeConfigBlockActiveDirectory } from './blockActiveDirectoryUser';


export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    '/login',
    routeConfig
  ).when(
    '/password',
    routeConfigPassword
  ).when(
    '/passwordReset',
    routeConfigPasswordReset
  ).when(
    '/blockActiveDirectory',
    routeConfigBlockActiveDirectory
  );
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.membership.routes loaded');
